type DeepAnalysisErrorProps = {
    userRequestId: string;
    error: string;
};

class DeepAnalysisError {
    userRequestId: string;

    error: string;

    constructor({ userRequestId, error }: DeepAnalysisErrorProps) {
        this.userRequestId = userRequestId;
        this.error = error;
    }
}

export default DeepAnalysisError;
